import { Globe } from 'lucide-react';
import { useLocaleTransition } from '../../context/LocaleTransitionContext';

export default function LanguageToggle({ className = '' }) {
  const { toggleLanguage, currentLanguage } = useLocaleTransition();

  const isKorean = currentLanguage === 'ko';

  return (
    <button
      onClick={toggleLanguage}
      className={`relative p-2 rounded-lg transition-colors hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus-ring ${className}`}
      aria-label={`Current language: ${isKorean ? 'Korean' : 'English'}. Click to switch.`}
    >
      <div className="flex items-center gap-1.5">
        <div className="relative w-4 h-4">
          <Globe className="w-4 h-4 text-gray-600 dark:text-gray-300" />
        </div>
        <div className="relative w-6 h-5 overflow-hidden hidden sm:block">
          {/* Show EN when in English */}
          <span
            className={`absolute inset-0 flex items-center text-sm font-medium text-gray-600 dark:text-gray-300 transition-all duration-300 ${
              isKorean
                ? 'opacity-0 -translate-y-full'
                : 'opacity-100 translate-y-0'
            }`}
          >
            EN
          </span>
          {/* Show KR when in Korean */}
          <span
            className={`absolute inset-0 flex items-center text-sm font-medium text-gray-600 dark:text-gray-300 transition-all duration-300 ${
              isKorean
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 translate-y-full'
            }`}
          >
            KR
          </span>
        </div>
        {/* Mobile: show current language */}
        <span className="sm:hidden text-xs font-medium text-gray-600 dark:text-gray-300">
          {isKorean ? 'KR' : 'EN'}
        </span>
      </div>
    </button>
  );
}
